export const dummyData1 = new Promise((resolve, reject) => {
    resolve(
        {
            data: {
                seasonalChallenges23:
                    [
                        {
                            name: "Season of the Deep Upgrades",
                            challenges: [
                                {
                                    belongsTo: "Season-of-the-Deep-Upgrades",
                                    name: "Deep Challenger",
                                    description: "Complete Week 1 of Into the Depths to unlock the following Seasonal bonus: Completing a Season of the Deep weekly activity challenge grants a chance to earn an additional Deep Engram when completing activities. Resets weekly",
                                    category: [],
                                    completed: true,
                                    challengeIndex: 0,
                                    objectives: [
                                        {
                                            isPercent: false,
                                            task: "",
                                            progress: 0,
                                            goal: 1,
                                            completed: true
                                        }
                                    ],
                                    reward: "Deep Challenger",
                                    xp: "Challenger XP",
                                    dust: null
                                },
                                {
                                    belongsTo: "Season-of-the-Deep-Upgrades",
                                    name: "Deep Armor Focusing",
                                    description: "Obtain a full set of Season of the Deep armor to unlock the following Seasonal bonus: Deep Engrams can be focused into individual pieces of high-stat Season of the Deep armor.",
                                    category: [
                                        "Gear"
                                    ],
                                    completed: false,
                                    challengeIndex: 1,
                                    objectives: [
                                        {
                                            isPercent: false,
                                            task: "NPA Weir-Walker Head",
                                            progress: 0,
                                            goal: 1,
                                            completed: false
                                        },
                                        {
                                            isPercent: false,
                                            task: "NPA Weir-Walker Arms",
                                            progress: 0,
                                            goal: 1,
                                            completed: false
                                        },
                                        {
                                            isPercent: false,
                                            task: "NPA Weir-Walker Chest",
                                            progress: 0,
                                            goal: 1,
                                            completed: false
                                        },
                                        {
                                            isPercent: false,
                                            task: "NPA Weir-Walker Legs",
                                            progress: 0,
                                            goal: 1,
                                            completed: false
                                        },
                                        {
                                            isPercent: false,
                                            task: "NPA Weir-Walker Class Item",
                                            progress: 0,
                                            goal: 1,
                                            completed: false
                                        }
                                    ],
                                    reward: "Deep Armor Focusing",
                                    xp: "Challenger XP",
                                    dust: null
                                },
                                {
                                    belongsTo: "Season-of-the-Deep-Upgrades",
                                    name: "Deep Weapon Focusing",
                                    description: "Obtain any 6 Season of the Deep or reprised Reckoning weapons to unlock the following Seasonal bonus: Deep Engrams can be focused into individual Season of the Deep or Reckoning weapons. The weapon must be acquired previously in order to focus it.",
                                    category: [
                                        "Gear"
                                    ],
                                    completed: false,
                                    challengeIndex: 2,
                                    objectives: [
                                        {
                                            isPercent: false,
                                            task: "Weapons",
                                            progress: 0,
                                            goal: 6,
                                            completed: false
                                        }
                                    ],
                                    reward: "Deep Weapon Focusing",
                                    xp: "Challenger XP",
                                    dust: null
                                },
                            ]
                        }
                    ]
            }
        }
    )
})

export const dummyData2 = {
    data: {
        seasonalChallenges23: [
            {
                name: "Season of-the-Deep-Upgrades",
                challenges: [
                    {
                        belongsTo: "Season-of-the-Deep-Upgrades",
                        name: "Deep Challenger",
                        description: "Complete Week 1 of Into the Depths to unlock the following Seasonal bonus: Completing a Season of the Deep weekly activity challenge grants a chance to earn an additional Deep Engram when completing activities. Resets weekly",
                        category: [],
                        completed: true,
                        challengeIndex: 0,
                        objectives: [
                            {
                                isPercent: false,
                                task: "",
                                progress: 0,
                                goal: 1,
                                completed: true
                            }
                        ],
                        reward: "Deep Challenger",
                        xp: "Challenger XP",
                        dust: null
                    },
                    {
                        belongsTo: "Season-of-the-Deep-Upgrades",
                        name: "Deep Armor Focusing",
                        description: "Obtain a full set of Season of the Deep armor to unlock the following Seasonal bonus: Deep Engrams can be focused into individual pieces of high-stat Season of the Deep armor.",
                        category: [
                            "Gear"
                        ],
                        completed: false,
                        challengeIndex: 1,
                        objectives: [
                            {
                                isPercent: false,
                                task: "NPA Weir-Walker Head",
                                progress: 0,
                                goal: 1,
                                completed: false
                            },
                            {
                                isPercent: false,
                                task: "NPA Weir-Walker Arms",
                                progress: 0,
                                goal: 1,
                                completed: false
                            },
                            {
                                isPercent: false,
                                task: "NPA Weir-Walker Chest",
                                progress: 0,
                                goal: 1,
                                completed: false
                            },
                            {
                                isPercent: false,
                                task: "NPA Weir-Walker Legs",
                                progress: 0,
                                goal: 1,
                                completed: false
                            },
                            {
                                isPercent: false,
                                task: "NPA Weir-Walker Class Item",
                                progress: 0,
                                goal: 1,
                                completed: false
                            }
                        ],
                        reward: "Deep Armor Focusing",
                        xp: "Challenger XP",
                        dust: null
                    },
                    {
                        belongsTo: "Season-of-the-Deep-Upgrades",
                        name: "Deep Weapon Focusing",
                        description: "Obtain any 6 Season of the Deep or reprised Reckoning weapons to unlock the following Seasonal bonus: Deep Engrams can be focused into individual Season of the Deep or Reckoning weapons. The weapon must be acquired previously in order to focus it.",
                        category: [
                            "Gear"
                        ],
                        completed: false,
                        challengeIndex: 2,
                        objectives: [
                            {
                                isPercent: false,
                                task: "Weapons",
                                progress: 0,
                                goal: 6,
                                completed: false
                            }
                        ],
                        reward: "Deep Weapon Focusing",
                        xp: "Challenger XP",
                        dust: null
                    },
                ]
            },
            {
                name: "Week One",
                challenges: [
                    {
                        belongsTo: "Week-One",
                        name: "Into the Depths I",
                        description: "Complete the Week 1 Into the Depths mission",
                        category: [],
                        completed: false,
                        challengeIndex: 0,
                        objectives: [
                            {
                                isPercent: false,
                                task: "",
                                progress: 0,
                                goal: 1,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: null
                    },
                    {
                        belongsTo: "Week-One",
                        name: "Front Line Salvager I",
                        description: "Complete Salvage or Deep Dive activities while using an Arc or Strand subclass. Additionally, defeat Fallen anywhere in the system.",
                        category: [
                            "Deep Dive",
                            "Salvage"
                        ],
                        completed: false,
                        challengeIndex: 1,
                        objectives: [
                            {
                                isPercent: false,
                                task: "Seasonal activities",
                                progress: 0,
                                goal: 3,
                                completed: false
                            },
                            {
                                isPercent: true,
                                task: "Fallen",
                                progress: 0,
                                goal: 100,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: null
                    },
                    {
                        belongsTo: "Week-One",
                        name: "Successful Salvager",
                        description: "Successfully complete jobs in Salvage activities.",
                        category: [
                            "Salvage"
                        ],
                        completed: false,
                        challengeIndex: 2,
                        objectives: [
                            {
                                isPercent: false,
                                task: "Jobs",
                                progress: 0,
                                goal: 5,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: null
                    }
                ]
            },
            {
                name: "Week Two",
                challenges: [
                    {
                        belongsTo: "Week-Two",
                        name: "Powerful Salvager",
                        description: "Defeat powerful combatants in Salvage activities.",
                        category: [
                            "Salvage"
                        ],
                        completed: false,
                        challengeIndex: 2,
                        objectives: [
                            {
                                isPercent: true,
                                task: "Powerful combatants",
                                progress: 0,
                                goal: 100,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: null
                    },
                    {
                        belongsTo: "Week-Two",
                        name: "Antithetical Armaments",
                        description: "Defeat targets with Shotguns or Sniper Rifles. Defeated Guardians or defeated combatants in Salvage or Deep Dive activities grant additional progress.",
                        category: [
                            "Loadout",
                            "Salvage",
                            "Deep Dive",
                            "Gambit",
                            "PvP"
                        ],
                        completed: false,
                        challengeIndex: 3,
                        objectives: [
                            {
                                isPercent: true,
                                task: "Shotgun or Sniper Rifle final blows",
                                progress: 0,
                                goal: 100,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: null
                    },
                    {
                        belongsTo: "Week-Two",
                        name: "Throne World Activities",
                        description: "In the Throne World, complete bounties and earn progress by completing patrols, public events, and looting Lost Sectors.",
                        category: [
                            "Throne World"
                        ],
                        completed: false,
                        challengeIndex: 4,
                        objectives: [
                            {
                                isPercent: true,
                                task: "Progress",
                                progress: 0,
                                goal: 100,
                                completed: false
                            }
                        ],
                        reward: null,
                        xp: "Challenger XP+",
                        dust: "Bright Dust"
                    },
                ]
            },
        ]
    }
};
